import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const MfaRoot = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const MfaStatus = styled.p`
	margin: 0;
	color: ${({ $enabled }) => ($enabled ? BTTO_PROFILE_COLORS.success : BTTO_PROFILE_COLORS.warning)};
	font-size: 14px;
	font-weight: 600;
`;

export const MfaDescription = styled.p`
	margin: 0;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 13px;
	line-height: 1.5;
`;

export const ModalOverlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 1200;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	padding: 80px 16px 24px;
	background: rgba(0, 0, 0, 0.65);
`;

export const ModalPanel = styled.div`
	width: 100%;
	max-width: 420px;
	padding: 24px;
	border-radius: 14px;
	background: ${BTTO_PROFILE_COLORS.surface};
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
`;

export const ModalTitle = styled.h3`
	margin: 0 0 8px;
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 16px;
	font-weight: 600;
	text-align: center;
`;

export const ModalInfo = styled.p`
	margin: 0 0 20px;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 13px;
	line-height: 1.5;
	text-align: center;
`;

export const QrWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 20px;

	img {
		width: 192px;
		height: 192px;
		border-radius: 12px;
	}
`;

export const CodeInput = styled.input`
	width: 100%;
	height: 44px;
	padding: 0 14px;
	border-radius: 8px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 14px;
	text-align: center;
`;

export const ModalActions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 16px;
`;

export const CloseButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 16px auto 0;
	padding: 0;
	border: none;
	background: transparent;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	cursor: pointer;
`;
